@import '@hevoio/hevo-ui-toolkit/styles/variables';

.fullScreenContent {
  width: 100%;
  height: 100%;
  background: $surface-bg;
  overflow: auto;
}

.fullScreenContentInner {
  height: 100%;
  width: 100%;
  background: $surface-bg;
  min-width: 1280px;
  min-height: 588px;
}
